var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
var symboll = window.shop_symbol;
if (document.querySelector('[name="country_code"]') != null) {
  symboll = document.querySelector('[name="country_code"]').getAttribute("symbol");
}
if (document.querySelector(".template--cart")) {
  var currentItemCount = Array.from(document.querySelector(".template--cart").querySelectorAll('[name="updates[]"]')).reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);
}
Shopify.money_format = symboll + "{{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";
    return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
  case "amount":
    value = formatWithDelimiters(cents, 2);
    break;
  case "amount_no_decimals":
    value = formatWithDelimiters(cents, 0);
    break;
  case "amount_with_comma_separator":
    value = formatWithDelimiters(cents, 2, ".", ",");
    break;
  case "amount_no_decimals_with_comma_separator":
    value = formatWithDelimiters(cents, 0, ".", ",");
    break;
  }
  return formatString.replace(placeholderRegex, value);
};
var languageRoot = Shopify.routes.root;
var languageRootRemovedLastSlash = languageRoot.slice(0, languageRoot.length - 1);
var isOpen = false;
var timer;
document.addEventListener("click", (event) => {
  var clickedAtcButton =
    event.target.closest(".add-to-cart-btn") ||
    event.target.closest(".product-form__submit");
  if (!clickedAtcButton) return; //do nothing
  event.preventDefault();
  event.stopPropagation();
  if (document.querySelector('.cart-notification-wrapper .cart-notification').classList.contains('active')) {
    document.querySelector('.cart-notification-wrapper .cart-notification').classList.remove('active');
  }
  var self = clickedAtcButton;
  var product_id = self.getAttribute("product_id");
  var metaf = self.getAttribute("metaf");
  var data = new FormData(self.closest("form"));

  addProductToCart(product_id, metaf, product_id, data, clickedAtcButton);
});
document.querySelector('.cart-notification-wrapper .cart-notification__close').addEventListener("click", (event) => {
  closeCart();
});
document.querySelector('.cart-notification-wrapper').addEventListener("keyup", (event) => {
  if (event.code.toUpperCase() !== "ESCAPE") return;
  removeTrapFocus(document.querySelector('.header__icon--cart'));
  closeCart();
});
document.body.addEventListener("click", (event) => {
  if (document.querySelector('.cart-notification-wrapper .cart-notification').classList.contains('active')) {
    document.querySelector('.cart-notification-wrapper .cart-notification').classList.remove('active');
  }
});
document.querySelector('.cart-notification-wrapper .cart-notification').addEventListener("click", (event) => {
  event.stopPropagation();
});


function addProductToCart(formID, metafields, productID, target, clickedAtcButton) {
  
  window.localStorage.setItem("timer", new Date().getTime() + 10 * 60 * 1000);

  // Check if there is name="properties[Recipient email]" on the product page
  if(document.querySelector('[name="properties[__shopify_send_gift_card_to_recipient]"]')){
    var send_gift = document.querySelector('[name="properties[__shopify_send_gift_card_to_recipient]"]');
    if(send_gift.checked && document.querySelector('[name="properties[Recipient email]"]')){
      if(!document.querySelector('[name="properties[Recipient email]"]').value){
        var parent = document.querySelector('[name="properties[Recipient email]"]').closest('.recipient-fields__field');
        parent.querySelector('.form__message .error-message').innerText = 'This field is required';
        parent.querySelector('.form__message').classList.remove('hidden');
        return;
      }else{
          var parent = document.querySelector('[name="properties[Recipient email]"]').closest('.recipient-fields__field');
          parent.querySelector('.form__message').classList.add('hidden');
      }
    }
  }
  
  fetch(window.routes.cart_add_url + ".js", {
      body: target,
      headers: {
        "X-Requested-With": "xmlhttprequest",
      },
      method: "POST",
    })
    .then(function (response) {
      return response.json();
    })
    .then(function addProductToCartSuccess(response) {
      if (response.status) {
        handleErrorMessage(response.description);
        return;
      }
      var data_id = response;
      /* gift wrap code */
      var productOrQuickViewWrapper = clickedAtcButton.closest(".quick-view_grid") || clickedAtcButton.closest(".product__detail");
      if (productOrQuickViewWrapper.querySelector(".product__wrapping") && productOrQuickViewWrapper.querySelector(".add_gift_wrapping").checked == true) {
        var gift_wrapping_container = productOrQuickViewWrapper.querySelector(".product__wrapping");
        var gift_wrapping_id = gift_wrapping_container.dataset.giftId;
        var message = gift_wrapping_container.querySelector("textarea").value;
        var product = gift_wrapping_container.dataset.giftProduct;
        var gift = {
          id: gift_wrapping_id,
          quantity: 1,
          properties: {
            _gift_wrapping_message: message,
            _gift_wrapping_product: product,
          },
        };
        var data = {
          items: [],
        };
        data["items"].push(gift);
        fetch(window.routes.cart_add_url + ".js", {
            body: JSON.stringify(data),
            credentials: "same-origin",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "xmlhttprequest",
            },
            method: "POST",
          })
          .then(function (response) {
            return response.json();
          })
          .then(function addProductToCartSuccess(response) {
            var this_data = response;
            addToCartOk(this_data, data_id);
          });
      } else {
        var data = response;
        addToCartOk('', data);
      }
    })
    .catch(function errorHandler(error) {
      console.warn(
        "Something went wrong with store.js addProductToCart.",
        error
      );
    });
  if (metafields != "") {
    window.localStorage.setItem("metafields-" + productID, metafields);
  }
  return false;
}

function handleErrorMessage(errorMessage = false) {
  let errorMessageWrappers = document.querySelectorAll(".product-form__error-message-wrapper");
  errorMessageWrappers.forEach(errorMessageWrapper => {
    let this_errorMessage = errorMessageWrapper.querySelector(".product-form__error-message");
    errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

  if (typeof errorMessage === 'object') {
    let entries = Object.entries(errorMessage)
    let data = entries.map( ([key, val] = entry) => {
      return `The ${key} ${val}`;
    });
    this_errorMessage.textContent = data;
  }else{
    this_errorMessage.textContent = errorMessage;
  }

    
  });
}

function testQty(itemID, value) {
  changeItem(itemID, value);
}

function fetchCart(line) {
  fetch(window.routes.cart_url + ".js")
    .then((response) => response.json())
    .then((response) => {
      var cart = response;
      onCartUpdate(cart);
      renderCart(cart, line);
    });
}

function changeItem(line, quantity, callback) {
  if (isNotLoading()) {
    startLoading();
  }
  // Check if this product has gift wrapping
  if (!!document.querySelector(`.cart [data-gift-product="${line}"]`)) {
    var new_id = document.querySelector(`.cart [data-gift-product="${line}"]`).dataset.product;
    var data = {};
    data["id"] = line.toString();
    data["quantity"] = quantity;
  } else {
    var data = {};
    data["id"] = line.toString();
    data["quantity"] = quantity;
  }
  var original_quantity = fetch(window.routes.cart_change_url + ".js", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
    .then(function (response) {
      return response.json();
    })
    .then(function (cart) {
      if (document.body.classList.contains("template--cart")) {
        // Error message
        const container = document.querySelector(".cart-page");
        const textwrapper = container.querySelector(`#Line-item-error-${line} .cart-item__error-text`);
        if (currentItemCount === cart.item_count) {
          var quantity = "";
          for (let index = 0; index < cart.items.length; index++) {
            const item = cart.items[index];
            if (item.id === line * 1) {
              quantity = item.quantity;
              if (container.querySelector(`[line-item-id='${line}']`).value) {}
            }
          }
          const text = window.cartStrings.quantityError.replace("[quantity]", quantity);
          if (textwrapper) textwrapper.textContent = text;
        } else {
          if (textwrapper) textwrapper.textContent = "";
        }
        currentItemCount = cart.item_count;
        if (!!document.querySelector(".products-cart")) {
          document
            .querySelectorAll(".products-cart")
            .forEach(function (productElem) {
              var elementRemove = 0;
              var elementId = productElem.dataset.idCart;
              cart.items.forEach(function (elem, index) {
                if (elem.id == elementId) {
                  elementRemove = 1;
                }
              });
              if (elementRemove == 0) {
                productElem.remove();
              }
            });
        }
        cart.items.forEach(function (item, index) {
          if (!!document.querySelector('[data-id-cart="' + item.id + '"]')) {
            var cartItemElem = document.querySelector('[data-id-cart="' + item.id + '"]');
            var cross_new = parseFloat(item.price) * parseFloat(item.quantity);
            cartItemElem.querySelector(".product-price-cart .price-cart").innerText = Shopify.formatMoney(item.final_price);
            if (!!cartItemElem.querySelector(".product-line-price del.cart-item__old-price")) {
              cartItemElem.querySelector(".product-line-price del.cart-item__old-price").innerText = Shopify.formatMoney(cross_new);
            }
            cartItemElem.querySelector(".product-line-price span").innerText = Shopify.formatMoney(item.final_line_price);
            cartItemElem.querySelector('[name="quantity"]').value = item.quantity;
            cartItemElem.querySelector('[name="quantity"]').setAttribute("value", item.quantity);
          }
        });
        if (!!document.querySelector("p.totals__subtotal-value")) {
          document.querySelector("p.totals__subtotal-value").innerText =
            Shopify.formatMoney(cart.total_price) + " " + Shopify.currency.active;
        }
      }
      if (typeof callback === "function") {
        callback(cart);
      } else {
        onCartUpdate(cart);
        fetchCart(line);
      }
      if (cart.item_count < 1) {
        if (!!document.querySelector(".cart-page")) {
          document.querySelector(".cart-page").innerHTML = `<div class="cart__warnings"> <h3 class="cart__empty-text mb-4">Your cart is empty</h3> <a href="${window.routes.collection_url}" class="link button button--primary"> Continue shopping </a> </div>`;
        }
      }
    })
    .catch(function (error) {
      // Catch errors
      console.warn(error);
    });
}

function removeItem(itemID) {
  if (!!document.querySelector(".item-" + itemID)) {
    changeItem(itemID, 0);
    document.querySelector(".item-" + itemID).remove();
  }
}

function onCartUpdate(cart) {
  // Do nothing, logic handled before render
}

function addToCartOk(target, product) {
  if (isNotLoading()) {
    startLoading();
  }
  openCart(product);
  setTimeout(() => fetchCart(), 300);
}

function addToCartFail() {
  console.warn("Error adding to cart: -------------------");
}

function renderCart(cart, line) {  
  if (document.querySelector(".header-cart-count")) {
    if (cart.item_count > 0) {
      document.querySelector(".header-cart-count").closest(".cart-count-bubble").style.display = "flex";
    } else {
      document.querySelector(".header-cart-count").closest(".cart-count-bubble").style.display = "none";
    }
    var get_cart_count = document.querySelectorAll(".header-cart-count");
    for (var i = 0; i < get_cart_count.length; i++) {
      get_cart_count[i].innerText = cart.item_count;
    }
  }

  stopLoading();
}

document.addEventListener("DOMContentLoaded", function () {
  fetchCart();
});

function closeCart() {
  document.querySelector('.cart-notification-wrapper .cart-notification').classList.remove('active');
}

function openCart(get_product) {
  var v_get_variant_id = get_product.variant_id;
  fetch(`/cart/?view=notification-cart`, {
    credentials: 'same-origin',
    method: 'GET'
  }).then((response) => {
    return response.text();
  }).then((html) => {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, "text/html");
    var get_new_content = doc.querySelector('.cart-notification-product-' + v_get_variant_id);
    document.querySelector('#cart-notification-product').innerHTML = '';
    document.querySelector('#cart-notification-product').append(get_new_content);
    if (document.querySelectorAll('.quick-view_grid').length > 1) {
      document.querySelector('.quick-view_grid').remove();
    }
    document.querySelector('.cart-notification-wrapper .cart-notification').classList.add('active');
    trapFocus(
      document.querySelector('.cart-notification-wrapper'),
      document.querySelector('.cart-notification__close')
    );
    fetch(window.routes.cart_url + ".js")
      .then((response) => response.json())
      .then((response) => {
        var cart = response;
        document.querySelector('.cart_count_popup').innerHTML = '(' + cart.item_count + ')';
        if (document.querySelector(".header-cart-count")) {
          if (cart.item_count > 0) {
            document.querySelectorAll(".cart-count-bubble").forEach(function (bubble) {
              bubble.style.display = "flex";
            });
          } else {
            document.querySelectorAll(".cart-count-bubble").forEach(function (bubble) {
              bubble.style.display = "none";
            });
          }
          var get_cart_count = document.querySelectorAll(".header-cart-count");
          for (var i = 0; i < get_cart_count.length; i++) {
            get_cart_count[i].innerText = cart.item_count;
          }
        }
      });
  });
}

function isCartOpen() {
  return isOpen;
}

function startLoading() {
  document.querySelector(".cartLoader")?.classList.remove("is-hidden");
}

function stopLoading() {
  document.querySelector(".cartLoader")?.classList.add("is-hidden");
}

function isNotLoading() {
  return document.querySelector(".cartLoader")?.classList.contains("is-hidden");
}

document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("change", (event) => {
    const changedColorRadio = event.target.closest(
      '[data_options="color"] input[type="radio"]'
    );
    if (!changedColorRadio) return; //do nothing
    if (changedColorRadio.value != undefined) {
      if (!!changedColorRadio.closest(".product-form__input")) {
        let productFormInput = changedColorRadio.closest(".product-form__input");
        if (!!productFormInput.querySelector(".form__label span")) {
          productFormInput.querySelector(".form__label span").innerText = changedColorRadio.value;
        }
      }
    }
  });
  var selectors = {
    termsCheckbox: ".cart__terms-checkbox",
    requiresTerms: false,
  };
  if (!!document.querySelector(".js-cart-terms-checkboxes")) {
    var termsCheckboxes = document.querySelectorAll(
      ".js-cart-terms-checkboxes"
    );
    var requiresTerms = true;
    termsCheckboxes.forEach(function (termsCheckbox) {
      termsCheckbox.addEventListener("change", function (event) {
        var checkedStatus = event.target.checked;
        termsCheckboxes.forEach(function (termsCheckbox) {
          termsCheckbox.checked = checkedStatus;
        });
      });
    });
  } else {
    var requiresTerms = false;
  }
  document.querySelectorAll("button.cart__checkout-button.button").forEach(function (checkoutButton) {
    checkoutButton.addEventListener("click", function (e) {
      if (requiresTerms == true) {
        if (document.querySelectorAll(".js-cart-terms-checkboxes")[0].checked) {
          // continue to checkout
        } else {
          alert(window.cartStrings.cartTermsConfirmation);
          e.preventDefault();
          return false;
        }
      }
      e.preventDefault();
      var closestForm = document.querySelectorAll('form[action="' + window.routes.cart_url + '"]')[0];
      var formData = new URLSearchParams(new FormData(closestForm)).toString();
      fetch(window.routes.cart_url, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          window.location.href = "/checkout";
        })
        .catch(function (error) {
          // Catch errors
          addToCartFail();
        });
    });
  });
});


document.querySelectorAll(".collection-product-item .grid-variant-input").forEach((swatch) => {
  swatch.addEventListener("click", (e) => {
    setTimeout(function () {
      const value = swatch
        .closest(".grid-options")
        .querySelector("select")
        .getAttribute("value");
      const variant = swatch
        .closest(".grid-options")
        .querySelector(`select option[value="${value}"]`);
      if (!variant) return;
      const unitPrice = variant.getAttribute("data-unit-price");

      // update unit price
      if (!unitPrice) {
        swatch
          .closest(".card-details__wrapper")
          .querySelector(".unit-price").style.visibility = "hidden";
      } else {
        swatch
          .closest(".card-details__wrapper")
          .querySelector(".unit-price").style.visibility = "visible";
        swatch
          .closest(".card-details__wrapper")
          .querySelector(".unit-price > dd > span:first-child").innerHTML =
          unitPrice;
      }
    }, 200);
  });
});